import React, { useEffect, useRef, useState } from 'react';
import { Grid, Divider } from '@material-ui/core';
import { Card, Header, NavLink, Typography } from '@rcg/ui-react';
import CalendarIcon from '@rcg/ui-react/lib/assets/svg/calendar';
import VerticalDivider from '@rcg/ui-react/lib/components/Icons/VerticalDivider';
import { buildCalendarStateObject } from '@rcg/ui-react/lib/utils/dates';
import Calendar from '../Calendar';
import Button from '../../../../UiComponents/Button';
import InputRangeDate from '../InputRangeDate';
import useStyles from './index.style';

const DatepickerMobile = (props) => {
  const classes = useStyles();
  const {
    datepickerIcon = <CalendarIcon />,
    dividerInputIcon = <VerticalDivider />,
    resetDatesButtonLabel,
    incomingStartDate,
    backOptionLabel,
    incomingEndDate,
    minAvailableDate,
    maxAvailableDate,
    startDate = new Date(),
    endDate = new Date(),
    yourDatesLabel,
    submitDatesButtonLabel,
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    handleCloseModal = () => {},
    onDateChange = () => {},
    resetCalendar = () => {},
    oneWay = false,
  } = props;
  const [state, setState] = useState({
    ...buildCalendarStateObject(startDate, endDate),
    scrolled: false,
  });
  const setDates = (dates) => {
    setState({ ...state, ...dates });
  };

  const monthRef = useRef(null);
  useEffect(() => {
    if (monthRef.current && !state.scrolled) {
      monthRef.current.scrollIntoView();
      setState({ ...state, scrolled: true });
    }
  }, [state]);
  const onCancelClick = () => {
    setState({ ...buildCalendarStateObject(startDate, endDate), scrolled: false });
    handleCloseModal();
  };
  const onDoneClick = () => {
    setState({ ...state, scrolled: false });
    onDateChange(state);
    handleCloseModal();
  };
  const onResetClick = () => {
    setState({ ...buildCalendarStateObject(incomingStartDate, incomingEndDate), scrolled: false });
    resetCalendar();
  };

  return (
    <div className={classes.mobileCalendar}>
      <div className={classes.datepickerHeaderFixed}>
        <Header position="relative" elevation={0}>
          <NavLink component="a" onClick={onCancelClick}>
            <Typography variant="body2" className={classes.datepickerHeaderLabel}>
              {backOptionLabel}
            </Typography>
          </NavLink>
        </Header>
        <Card className={classes.wrapDatepickerMobile}>
          <div className={classes.datepickerHeader}>
            <div>
              <Grid container>
                <Grid item sm={12} className={classes.datepickerHeaderItem}>
                  <InputRangeDate
                    datepickerIcon={datepickerIcon}
                    dividerInputIcon={dividerInputIcon}
                    placeholderStartDate={placeholderStartDate}
                    placeholderEndDate={placeholderEndDate}
                    labelDatepicker=""
                    startDate={state.startDate}
                    endDate={state.endDate}
                    focusedInput={state.focusedInput}
                    oneWay={oneWay}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <div className={classes.datepickerMessages}>
            <div className={classes.underscore} /> {yourDatesLabel}
          </div>
        </Card>
      </div>
      <div className={classes.rootDatepickerMobile}>
        <Calendar
          maxAvailableDate={maxAvailableDate}
          minAvailableDate={minAvailableDate}
          incomingStartDate={incomingStartDate}
          incomingEndDate={incomingEndDate}
          startDate={state.startDate}
          endDate={state.endDate}
          onDateChange={setDates}
          numberOfMonths={0}
          monthRef={monthRef}
          singleDaySelection={oneWay}
        />
      </div>
      <div className={classes.actionsFixed}>
        <Divider />
        <Grid container>
          <Grid item md={12} sm={12} xs={12}>
            <div className={classes.mobileButtonsGroup}>
              <div className={classes.mobileButtons}>
                <Button
                  className={classes.resetButtonMobile}
                  data-testid="resetDatesMobile"
                  onClick={onResetClick}>
                  {resetDatesButtonLabel}
                </Button>
                <Button
                  data-testid="doneButtonMobile"
                  className={classes.doneButton}
                  variant="contained"
                  color="primary"
                  onClick={onDoneClick}>
                  {submitDatesButtonLabel}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DatepickerMobile;
